import { c as _c } from "react/compiler-runtime";
import { Select } from 'design-system/client';
import * as CountryList from 'i18n-iso-countries';
import de from 'i18n-iso-countries/langs/de.json';
import en from 'i18n-iso-countries/langs/en.json';
import { useTranslations, useLocale } from 'next-intl';
import { memo } from 'react';
import type { AddressFieldsProps } from './types';
import useRequiredComponent from './useRequiredComponent';
import type { Locale } from '@/i18n/types';
CountryList.registerLocale(de);
CountryList.registerLocale(en);
const CountryFieldOptions = memo(function CountryFieldOptions({
  locale
}: {
  locale: Locale;
}) {
  const countries = CountryList.getNames(locale);
  return Object.keys(countries).map(alpha2 => <option value={alpha2} key={alpha2}>
      {countries[alpha2]}
    </option>);
});
function CountryField(t0) {
  const $ = _c(8);
  const {
    required
  } = t0;
  const locale = useLocale();
  const FieldComponent = useRequiredComponent(required);
  const t = useTranslations("nextjs.donate.attributes");
  let t1;
  if ($[0] !== t) {
    t1 = t("country");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const label = t1;
  let t2;
  if ($[2] !== locale) {
    t2 = <CountryFieldOptions locale={locale} />;
    $[2] = locale;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== FieldComponent || $[5] !== label || $[6] !== t2) {
    t3 = <div><FieldComponent name="country_alpha2" title={label} as={Select}>{t2}</FieldComponent></div>;
    $[4] = FieldComponent;
    $[5] = label;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
export default CountryField;